import type { TFunction } from 'i18next';

import type { Community } from '~/interfaces/community';

export const getJoinRefusalMessage = (community: Pick<Community, 'gate'> | null | undefined, t: TFunction): string =>
  community?.gate?.message ?? t('community.join_refused.default_message');
